import { EntityBase } from './EntityBase';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class TypeWorkflowAction extends EntityBase {

   /// <code> Place custom code between <code> tags
   
   /// </code>

   // Generated code. Do not place code below this line.
   typeWorkflowActionId: string;
   description: string;
   toCompleteDescription: string;
   includeInStaffReport: boolean;
   canDeleteFromWorkflowHistory: boolean;
   completedOnlyType: boolean;
   coreData: boolean;
   rowVersion: number;
}

